import React, { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { stopwatchEdit, stopwatchStart } from "~/store/actions/actions.stopwatches";
import { formatTime } from "~/utils/date";
import { timeToMinutes } from "~/utils/utils";
import NonTickingElapsedTime from "./NonTickingElapsedTime";
import TickingElapsedTime from "./TickingElapsedTime";

const ElapsedTime = ({ id, started_on, elapsed, exitEditMode, onClick, parentId, parentType }) => {
  const dispatch = useDispatch();

  const editStopwatch = useCallback(
    (updatedElapsed) => {
      return dispatch(stopwatchEdit(id, { elapsed: updatedElapsed }));
    },
    [dispatch, id]
  );

  const createStopwatch = useCallback(
    (elapsed) => {
      return dispatch(stopwatchStart(parentType, parentId, elapsed));
    },
    [dispatch, parentId, parentType]
  );

  const handleOnSave = useCallback(
    (e) => {
      const updatedElapsed = timeToMinutes(e.target.value) * 60;
      exitEditMode();
      if (!id) {
        return createStopwatch(updatedElapsed);
      }
      return editStopwatch(updatedElapsed);
    },
    [createStopwatch, editStopwatch, exitEditMode, id]
  );

  const handleOnCancel = useCallback(() => {
    exitEditMode();
  }, [exitEditMode]);

  const [hoursNotRunning, minutesNotRunning] = formatTime(elapsed);

  const props = useMemo(() => {
    return {
      id,
      onClick,
      onSave: handleOnSave,
      onCancel: handleOnCancel,
      hoursNotRunning,
      minutesNotRunning,
    };
  }, [handleOnCancel, handleOnSave, hoursNotRunning, id, minutesNotRunning, onClick]);

  return started_on ? <TickingElapsedTime {...props} /> : <NonTickingElapsedTime {...props} />;
};

ElapsedTime.propTypes = {
  elapsed: PropTypes.number.isRequired,
  started_on: PropTypes.number,
  onClick: PropTypes.func,
  id: PropTypes.number,
  parentType: PropTypes.string,
  exitEditMode: PropTypes.func,
  parentId: PropTypes.number,
};

ElapsedTime.defaultProps = {
  started_on: null,
  onClick: () => null,
};

export default ElapsedTime;
